import React, { useMemo } from "react";
import { Permission } from "./PermissionProvider";
import usePermission from "./usePermission";

interface RestrictedProps {
	to: Permission;
	children: React.ReactNode;
	fallback?: React.ReactNode | string;
	loadingComponent?: React.ReactNode | string;
	setIsAllowed?: React.Dispatch<React.SetStateAction<boolean>>;
}

// This component is meant to be used everywhere a restriction based on user permission is needed
const Restricted: React.FunctionComponent<RestrictedProps> = ({
	to,
	fallback,
	loadingComponent,
	children,
}) => {
	// connect to the provider through PermissionContext
	const [loading, allowed] = usePermission(to);

	if (loading) return <>{loadingComponent}</>; // Ensure return is valid
	return allowed ? <>{children}</> : <>{fallback}</>; //Render children if allowed, fallback if not allowed
};

export default Restricted;
